// 智慧访客
import Log from "../view/log";
import VisitorNav from "../view/VisitorCenter/VisitorNav";
import VisitorOverView from "../view/VisitorCenter/VisitorOverView/VisitorOverView";
import VisitorConfig from "../view/VisitorCenter/VisitorConfig/VisitorConfig";
import VisitorConfigModify from "../view/VisitorCenter/VisitorConfig/VisitorConfigModify";
import VisitorDeviceManage from "../view/VisitorCenter/VisitorDevice/VisitorDeviceManage";
import VisitorDeviceAdd from "../view/VisitorCenter/VisitorDevice/VisitorDeviceAdd";
import VisitorDeviceModify from "../view/VisitorCenter/VisitorDevice/VisitorDeviceModify";
import VisitorRegister from "../view/VisitorCenter/VisitorRegister/VisitorRegister";
import AppointmentRecord from "../view/VisitorCenter/AppointmentRecord/AppointmentRecord";
import CreditCardRecord from "../view/VisitorCenter/CreditCardRecord/CreditCardRecord";

export default [
  /* 智慧访客 */
  {
    path: "/visitor_over_view",
    name: "visitor-over-view",
    components: {
      default: VisitorNav,
      a: VisitorOverView
    }
  },
  {
    path: "/visitor_config",
    name: "visitor-config",
    components: {
      default: VisitorNav,
      a: VisitorConfig
    }
  },
  {
    path: "/visitor_config_modify",
    name: "visitor-config-modify",
    components: {
      default: VisitorNav,
      a: VisitorConfigModify
    }
  },
  {
    path: "/visitor_device_manage",
    name: "visitor-device-manage",
    components: {
      default: VisitorNav,
      a: VisitorDeviceManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/visitor_device_add",
    name: "visitor-device-add",
    components: {
      default: VisitorNav,
      a: VisitorDeviceAdd
    }
  },
  {
    path: "/visitor_device_modify",
    name: "visitor-device-modify",
    components: {
      default: VisitorNav,
      a: VisitorDeviceModify
    }
  },
  {
    path: "/visitor_register",
    name: "visitor-register",
    components: {
      default: VisitorNav,
      a: VisitorRegister
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/appointment_record",
    name: "appointment-record",
    components: {
      default: VisitorNav,
      a: AppointmentRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/credit_card_record",
    name: "credit-card-record",
    components: {
      default: VisitorNav,
      a: CreditCardRecord
    },
    meta: {
      keepAlive: true
    }
  },
  /* 智慧访客 */

  // 智慧访客操作日志
  {
    path: "/visitor_service_log",
    name: "visitor-service-log",
    components: {
      default: VisitorNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/Visitor.js